// Auto-generated by version bump script
export const APP_VERSION = '1.0.21';
export const BUILD_DATE = '2026-07-18T15:23:09.046Z';
